// Brand-wide constants used across the site
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dental-admin-hub-2/artifacts/k715mfhv_IMG-20260424-WA0025.jpg";

export const PHONE_DISPLAY = "(876) 729-5735";
export const PHONE_TEL = "+18767295735";

export const WHATSAPP_DISPLAY = "(876) 206-8929";
export const WHATSAPP_NUMBER = "18762068929";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Be Dental Paradise! I'd like to book an appointment."
)}`;

export const EMAIL = "bedentalparadise@gmail.com";
export const FACEBOOK = "https://facebook.com/bedentalparadise";
export const FACEBOOK_HANDLE = "@Be Dental Paradise";

export const HOURS = [
  { d: "Mon - Fri", t: "9:00 am - 5:00 pm" },
  { d: "Saturday", t: "9:00 am - 12:00 pm" },
  { d: "Sunday", t: "Closed" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES_LIST = [
  "Examination",
  "Cleaning",
  "Teeth Whitening",
  "Fillings",
  "Crown & Bridge",
  "Dentures",
  "Extractions",
  "Root Canals",
  "Minor Oral Surgery",
];
